import { Link } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Button, Skeleton, Typography } from "@mui/material";
import { Stack } from "@mui/system";

import { useCustomerContext } from "../../../../Context/CustomerContext";
import { useCustomerHasFsk8sAWSPermissions, useCustomerHasFsk8sGCPPermissions } from "../../hooks";

interface SuccessTextProps {
  text: string;
}

const SuccessText = ({ text }: SuccessTextProps) => (
  <Stack direction="row" gap="4px" alignItems="center" justifyContent="center">
    <CheckCircleIcon color="success" fontSize="small" />
    <Typography fontWeight={400} fontSize={13}>
      {text}
    </Typography>
  </Stack>
);

const Fsk8sCloudPermissions = () => {
  const { customer } = useCustomerContext();

  const { customerHasFsk8sAWSPermissions, loading: awsLoading } = useCustomerHasFsk8sAWSPermissions();
  const { customerHasFsk8sGcpPermissions, loading: gcpLoading } = useCustomerHasFsk8sGCPPermissions();

  if (awsLoading || gcpLoading) {
    return <Skeleton variant="rectangular" width="100%" height={33} animation="wave" />;
  }

  if (customerHasFsk8sAWSPermissions && customerHasFsk8sGcpPermissions) {
    return <SuccessText text="AWS and Google Cloud permissions" />;
  }

  const eksButton = (
    <Button
      component={Link}
      to={`/customers/${customer.id}/settings/aws`}
      variant="outlined"
      sx={{ width: "fit-content" }}
    >
      EKS permissions
    </Button>
  );

  const gkeButton = (
    <Button
      component={Link}
      to={`/customers/${customer.id}/settings/gcp`}
      variant="outlined"
      sx={{ width: "fit-content" }}
    >
      GKE permissions
    </Button>
  );

  return (
    <>
      {customerHasFsk8sAWSPermissions ? <SuccessText text="AWS permissions" /> : eksButton}
      {customerHasFsk8sGcpPermissions ? <SuccessText text="Google Cloud permissions" /> : gkeButton}
    </>
  );
};

export default Fsk8sCloudPermissions;
